"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HodOnboardingExtraDataTypes = void 0;
const CommonOnboardingExtraDataTypes_1 = require("../../common/domain/CommonOnboardingExtraDataTypes");
const keyedRecord_1 = require("../../infrastructure/keyedRecord");
exports.HodOnboardingExtraDataTypes = Object.assign({}, CommonOnboardingExtraDataTypes_1.CommonOnboardingExtraDataTypes, (0, keyedRecord_1.keyedRecord)()({}));
//# sourceMappingURL=HodOnboardingExtraDataTypes.js.map